import React, { Component } from 'react'
import JSONP from 'ROOT_SOURCE/utils/jsonp'

import './index.scss'

// 经营信息
class Business extends Component {
    constructor() {
        super()
        this.state = {
            businessInfo: {}
        }
    }

    componentDidMount() {
        const _this = this;

        JSONP({
            url: `https://emsapi.58.com/api/ems/get${/qiangui\./.test(window.location.host) ? '' : '/test'}/data?id=20181011000012`,
            callback: function (res) {
                _this.setState({ businessInfo: res.list[20181011000012] })
            }
        })

    }
    render() {
        const {
            accumulated_loan_amount,
            accumulated_loan_count,
            loan_balance,
            loan_balance_count,
            accumulated_lenders_count,
            accumulated_borrowers_count,
            current_lenders_count,
            current_borrowers_count,
            top_ten_borrowers_account,
            largest_borrower_ratio,
            relationship_loan_balance,
            relationship_loan_count,
            overdue_amount,
            overdue_count,
            overdue_90days_amount,
            overdue_90days_count,
            accumulated_compensatory_amount,
            accumulated_compensatory_count,
            deadline
        } = this.state.businessInfo;
        return (
            <div className="Business">
                <h2 className="title">
                    经营信息
                    <p className="right-title">统计截止时间：{deadline || ''}</p>
                </h2>
                <ul className="contents">
                    <li>累计借贷金额(元)：{accumulated_loan_amount || ''}</li>
                    <li>累计借贷笔数：{accumulated_loan_count || ''}</li>
                    <li>借贷余额(元)：{loan_balance || ''}</li>
                    <li>借贷余额笔数：{loan_balance_count || ''}</li>
                    <li>累计出借人数量：{accumulated_lenders_count || ''}</li>
                    <li>累计借款人数量：{accumulated_borrowers_count || ''}</li>
                    <li>当前出借人数量：{current_lenders_count || ''}</li>
                    <li>当前借款人数量：{current_borrowers_count || ''}</li>
                    <li>前十大借款人待还金额占比(%)：{top_ten_borrowers_account || ''}</li>
                    <li>最大单一借款人待还金额占比(%)：{largest_borrower_ratio || ''}</li>
                    <li>关联关系借款余额(元)：{relationship_loan_balance || ''}</li>
                    <li>关联关系借款笔数：{relationship_loan_count || ''}</li>
                    <li>逾期金额(元)：{overdue_amount || ''}</li>
                    <li>逾期笔数：{overdue_count || ''}</li>
                    <li>逾期90天（不含）以上金额(元)：{overdue_90days_amount || ''}</li>
                    <li>逾期90天（不含）以上笔数：{overdue_90days_count || ''}</li>
                    <li>累计代偿金额(元)：{accumulated_compensatory_amount || ''}</li>
                    <li>累计代偿笔数：{accumulated_compensatory_count || ''}</li>
                </ul>
                <h2 className="title">收费标准</h2>
                <div className="contents">
                    <table border="1">
                        <tr>
                            <th>收费对象</th>
                            <th colspan="2">业务类型</th>
                            <th className="right-th">收费详情</th>
                        </tr>
                        <tr>
                            <td rowspan="8">投资人</td>
                            <td colspan="2">注册</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td colspan="2">开户</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td rowspan="3">投标</td>
                            <td>散标</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td>转让标</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td>授权投资类产品</td>
                            <td>投资人所选的授权投资类产品，其对应的借款实际利息收入中，超过产品参考年化回报率以外的部分作为服务费用归58钱柜所有，若实际获得利息不达参考年化回报率的，58钱柜不收取服务费用。详情参见所选产品的服务协议</td>
                        </tr>
                        <tr>
                            <td colspan="2">债权转让</td>
                            <td>债权转让服务费 = 成交日债权价值 * 0.3%</td>
                        </tr>
                        <tr>
                            <td colspan="2">充值</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td colspan="2">提现</td>
                            <td>免费</td>
                        </tr>
                        <tr>
                            <td>借款人</td>
                            <td colspan="2">/</td>
                            <td>依据风险定价，具体费率以借款时相关合同为准</td>
                        </tr>
                    </table>
                </div>
                <h2 className="title">统计口径</h2>
                <ul className="contents">
                    <li>披露说明请参照：《中国银监会办公厅关于印发 网络借贷信息中介机构业务活动 信息披露指引的通知》</li>
                </ul>
            </div>
        )
    }

}

export default Business;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/Business/index.js